import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

export interface VehicleRateModel {
  __type?: string;
  CaseSeries: string | null;
  CaseNumber: string | null;
  EngineNumber: string | null;
  ChasisNumber: string | null;
  VehicleRate: string | null;
}

@Injectable({
  providedIn: "root",
})
export class UpdateVehicleRateService {
  constructor(private http: HttpUtilService) {}

  getVehicleRateList(caseSeries: string): Observable<any> {
    return this.http.get(
      `UpdateVehicleRateService.asmx/GetVehicleRateList?caseSeries=${encodeURIComponent(JSON.stringify(caseSeries))}`,
    );
  }

  updateVehicleRate(payload: {
    model: VehicleRateModel;
  }): Observable<any> {
    return this.http.post(
      `UpdateVehicleRateService.asmx/UpdateVehicleRate`,
      payload,
    );
  }
}
